import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { useSelector } from 'react-redux';
import { getHasMabAccess } from '../selectors';
const fetchMabExperiment = ({
  mabExperimentId,
  isLandingPage
}) => {
  return http.get(`cospages/v2/dashboard/${isLandingPage ? 'landing' : 'site'}-pages/mab-get-experiment/${mabExperimentId}`).then(({
    mabExperiment,
    master,
    variants
  }) => {
    const allVariants = [master, ...variants];
    const allVariantsMap = allVariants.reduce((acc, variant) => {
      acc[variant.id] = variant;
      return acc;
    }, {});
    const allVariantsList = allVariants.map(({
      id,
      name
    }) => ({
      id,
      name
    }));
    return {
      mabExperiment: {
        deletedAt: mabExperiment.deletedAt,
        id: mabExperiment.id,
        metric: 'submissionsPerPageview',
        startedAt: mabExperiment.startedAt
      },
      mabVariantsMap: allVariantsMap,
      mabVariantsList: allVariantsList
    };
  });
};
const MabExperimentQuery = registerQuery({
  fieldName: 'mabInfo',
  fetcher: fetchMabExperiment
});
const useMabExperiment = ({
  mabExperimentId,
  isLandingPage
}) => {
  const hasMabAccess = useSelector(getHasMabAccess);
  const {
    data,
    loading,
    error
  } = useQuery(MabExperimentQuery, {
    variables: {
      mabExperimentId: mabExperimentId,
      isLandingPage
    },
    skip: !mabExperimentId
  });
  return useMemo(() => ({
    mabInfo: data === null || data === void 0 ? void 0 : data.mabInfo,
    hasMab: hasMabAccess && data !== null && data !== void 0 && data.mabInfo ? (data === null || data === void 0 ? void 0 : data.mabInfo.mabVariantsList.length) > 0 : false,
    mabRequestLoading: loading,
    mabRequestError: error
  }), [data, error, loading, hasMabAccess]);
};
export default useMabExperiment;